// src/components/admin/page-management/section-forms/ButtonForm.js
import React from 'react';

const ButtonForm = ({ content, updateContent }) => {
  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Button Section</h3>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Button Text</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.buttonText || ''}
          onChange={(e) => updateContent('buttonText', e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Button Link</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.buttonLink || ''}
          onChange={(e) => updateContent('buttonLink', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Use relative URLs like '/about' for internal links or full URLs like 'https://example.com' for external links.
        </p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Button Style</label>
        <select
          className="w-full p-2 border rounded"
          value={content?.buttonStyle || 'primary'}
          onChange={(e) => updateContent('buttonStyle', e.target.value)}
        >
          <option value="primary">Primary</option>
          <option value="secondary">Secondary</option>
          <option value="outline">Outline</option>
          <option value="link">Link</option>
        </select>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Alignment</label>
        <select
          className="w-full p-2 border rounded"
          value={content?.alignment || 'center'}
          onChange={(e) => updateContent('alignment', e.target.value)}
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>
    </div>
  );
};

export default ButtonForm;